import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    templateUrl: "./privacy.modal.component.html"
    ,styleUrls: ["./privacy.modal.component.scss"]
})
export class PrivacyModalComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;

    constructor(
        public activeModal: NgbActiveModal
    ) { }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {}

    clickCancel(){
        this.activeModal.close({
            "type":"cancel"
        });
    }
}